import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';


export const AccountManagersSectionSkeleton = () => (
    <FormSection
        headline="Account Team"
        info={() => (
            <Item grow={1}>
                <Group justify="space-between" alignItems="center">
                    <SkeletonItem width={140} height={28}/>
                    <SkeletonItem width={23} height={18}/>
                </Group>
            </Item>
        )}>
        <Group direction="v" gap="m" alignItems="start">
            <Group alignItems="center">
                <SkeletonItem circle={true} width={32} height={32}/>
                <SkeletonItem width={108} height={18}/>
                <SkeletonItem width={220} height={18}/>
            </Group>
        </Group>
    </FormSection>
);
